import React, { Component } from 'react';
import Parse from 'parse'
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { TextLink, Heading3, Spinner, SocialWrapper, CenteredText, TextField, GridRow, FullWidthSection, Heading2, withColor, withStyle, Section, Heading1, BiggerText, Text, SectionHeading, Link, FullWidthWrapper, PrimaryButton, SecondaryButton, Heading4 } from './MarketingStyles';

import MultistepForm from '../onboarding/MultistepForm';

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';

import { trackEvent } from "../../utils/eventTracking"
import checkmark from '../../images/icons/checkmark.svg'
import failuremark from '../../images/icons/failuremark.svg'
import spinnerCircle from '../../images/icons/spinner-circle.svg'
import { Facebook, LinkedIn } from '../../images/icons/Icons';

@inject('utilStore', 'translationStore')
@observer
class GolfCourseCooperationSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const data = e.target

    if(data.honey && data.honey.value !== '') {
      console.log('bot detected');
      return
    }

    this.form.selectSub(1)

    

    trackEvent( 'Contact - Golfclub Cooperation Formular', 'Golfclub Contact', 'Form Submission' )

    const request = new (Parse.Object.extend("GolfCourseRequest"))()

    request.set("course_name", data.course_name.value)
    request.set("street", data.street.value)
    request.set("city", data.city.value)
    request.set("postcode", Number(data.postcode.value))
    request.set("lastname", data.lastname.value)
    request.set("firstname", data.firstname.value)
    request.set("phone", data.phone.value)
    request.set("mail", data.mail.value)

    request.save().then(() => {
      this.form.selectSub(2)
    }).catch(e => {
      console.error(e)
      this.form.selectSub(3)
    })

  }

  render() {

    const { golf_course_benefits, social_links, golf_course_page } = this.props.utilStore.util

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    const SocialSection = () => (
      <SocialWrapper>
        <Link href={ social_links && social_links.facebook } target="_blank"><Facebook /></Link>
        <Link href={ social_links && social_links.linkedin } target="_blank"><LinkedIn /></Link>
      </SocialWrapper>
    )

    const CooperationForm = () => {

      return (
        <FullWidthWrapper>
          <Heading4>Kooperation anfragen</Heading4>
          <Heading2>Jetzt mit dem THE LOGE Netzwerk kooperieren.</Heading2>
          <Text>
            Um bei THE LOGE teilnehmen zu können benötigen wir folgende Daten von Ihnen. Die Daten werden gemäß unsere <a href="/datenschutz">DSGVO</a> verarbeitet.
          </Text>
          <form onSubmit={ this.handleSubmit }>
            <GridRow desktop="1fr" phone="1fr">
              <TextField name="course_name" placeholder="Name des Golfclubs *" required />
            </GridRow>
            <GridRow desktop="2fr 1fr 1fr" phone="1fr">
              <TextField name="street" placeholder="Straße *" required />
              <TextField name="city" placeholder="Ort *" required />
              <TextField name="postcode" placeholder="PLZ *" required />
            </GridRow>
            <GridRow desktop="1fr 1fr" phone="1fr">
              <TextField name="lastname" placeholder="Nachname *" required />
              <TextField name="firstname" placeholder="Vorname *" required />
            </GridRow>
            <GridRow desktop="1fr" phone="1fr">
              <TextField name="phone" placeholder="Telefonnummer *" required />
              <TextField name="mail" placeholder="Mail-Adresse *" type="email" required />
            </GridRow>

            <TextField name="honey" style={{display: 'none'}} />

            <GridRow desktop="1fr" phone="1fr" phoneRowGap>
              <PrimaryButton
                style={{marginTop: 30}}
                value="senden"
              />
            </GridRow>

          </form>
        </FullWidthWrapper>
      )
    }

    const Loading = () => {
      return (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <Spinner src={ spinnerCircle } />
        </FullWidthWrapper>
      )
    }

    const CooperationSuccess = () => {
      return (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ checkmark } style={{marginBottom: 50}} />
          <Heading2>Vielen Dank für Ihre Anfrage.</Heading2>
          <CenteredText>
            Wir melden uns in Kürze bei Ihnen. Falls Sie bis dahin noch Fragen haben sind wir gerne für Sie erreichbar. Besuchen Sie uns doch auch auf unseren Social Media Kanälen.
          </CenteredText>
          <SocialSection />
        </FullWidthWrapper>
      )
    }

    const CooperationError = ({ selectSub }) => {
      return (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ failuremark } style={{marginBottom: 50}} />
          <Heading2>Leider gab es einen Fehler!</Heading2>
          <CenteredText>
            Bitte versuchen Sie es erneut, oder kontaktieren Sie uns <a href="/kontakt">HIER</a>
          </CenteredText>
          <GridRow
            style={{margin: '30px 0', textAlign: 'center'}}
            desktop="1fr"
            phone="1fr"
            phoneRowGap
          >
            <PrimaryButton
              value="erneut versuchen"
              onClick={ () => selectSub(0) }
            />
          </GridRow>
        </FullWidthWrapper>
      )
    }

    const steps = [
      {
        title: "Kopperation",
        components: [
          () => <CooperationForm />,
          () => <Loading />,
          () => <CooperationSuccess />,
          () => <CooperationError />,
        ],
      }
    ]

    return (
      <FullWidthWrapper>
        <Section>
          <GridRow
            desktop="1fr 1fr"
            tablet="1fr"
            style={{gridColumnGap: 100}}
          >
            <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref } } />

            <ContactGrid desktop="1fr 2fr" phone="1fr">
              <ContactImage src={`${config.get('CLOUDINARY_URL')}${ golf_course_page && golf_course_page.schnoell_image } `} />
              <div>
                <Heading4>{ text('marketing_gc_landingpage__cooperation_text') }</Heading4>
                <Heading2>{ text('marketing_gc_landingpage__cooperation_name') }</Heading2>
                <Heading3>{ text('marketing_gc_landingpage__cooperation_jobtitle') }</Heading3>
                <TextLink style={{paddingBottom: 0, paddingTop: 20}} onClick={ e => { e.preventDefault(); window.open("mailto:" + text('marketing_gc_landingpage__email').replace(" [at] ", "@"), "_blank") } }>{ text('marketing_gc_landingpage__email')}</TextLink><br />
                <TextLink href={'tel:' + text('marketing_gc_landingpage__phone') }>{ text('marketing_gc_landingpage__phone') }</TextLink>
              </div>
            </ContactGrid>
          </GridRow>
        </Section>
        <FullWidthSection>
          <BottomImage src={`${config.get('CLOUDINARY_URL')}${ golf_course_page && golf_course_page.cooperation_image } `} />
        </FullWidthSection>
      </FullWidthWrapper>
    )
  }
}

export default GolfCourseCooperationSection

const ContactGrid = styled(GridRow) `
  height: auto;
  margin: auto 0;
`

const ContactImage = styled.img `
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: bottom;
  margin: auto 0 0 0;

  ${ cssVar.breakpoints.phone } {
    max-width: 70%;
    margin: 40px 15% 40px 15%;
  }
`

const BottomImage = styled.img `
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: cover;
  object-position: top;
  margin-top: -40px;
`



// WEBPACK FOOTER //
// /src/components/marketing/GolfCourseCooperationSection.js